/**
 * Determines which page numbers to display, and where to place ellipsis.
 * For expected behavior, see getControls.test.ts
 * @param indexLimit The maximum index of the page numbers, 0-based
 * @param currentIndex The current index, 0-based
 * @returns An array of page numbers to render (1-based) and ellipsis for ommited numbers
 */
export function getControls(indexLimit: number, currentIndex: number) {
  if (indexLimit <= 4) return Array.from({ length: indexLimit + 1 }, (_, i) => i + 1);
  const userFacingIndexLimit = indexLimit + 1;
  if (currentIndex <= 1) {
    return [1, 2, 3, '...', userFacingIndexLimit];
  }
  if (currentIndex === 2) {
    return [1, 2, 3, 4, '...', userFacingIndexLimit];
  }
  if (currentIndex === indexLimit - 2) {
    return [
      1,
      '...',
      userFacingIndexLimit - 3,
      userFacingIndexLimit - 2,
      userFacingIndexLimit - 1,
      userFacingIndexLimit,
    ];
  }
  if (currentIndex >= indexLimit - 1) {
    return [1, '...', userFacingIndexLimit - 2, userFacingIndexLimit - 1, userFacingIndexLimit];
  }
  const userFacingIndex = currentIndex + 1;
  return [1, '...', userFacingIndex - 1, userFacingIndex, userFacingIndex + 1, '...', userFacingIndexLimit];
}
